import { render, staticRenderFns } from "./nong-cun-chan-quan.vue?vue&type=template&id=5fa49b29&scoped=true&"
import script from "./nong-cun-chan-quan.vue?vue&type=script&lang=js&"
export * from "./nong-cun-chan-quan.vue?vue&type=script&lang=js&"
import style0 from "./nong-cun-chan-quan.vue?vue&type=style&index=0&id=5fa49b29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa49b29",
  null
  
)

export default component.exports